// extracted by mini-css-extract-plugin
export default {"companyContainer":"NL-z","companyImage":"OL-z","container":"PL-z","heading":"QL-z","darkText":"RL-z","smallHeading":"SL-z","darkBackground":"TL-z","whiteBackground":"UL-z"};